import { useMediaQuery, useTheme } from '@mui/material';

import { getLogger } from '@/logging/logger';
import { PageContentsItem } from '@/types/generated';
import { TDisplayScreen } from '@/types';
import { canDisplayContentOnScreen } from '@/utils';
import { useAppContext } from '@/context/AppContextProvider.ctx';

import { getComponentMapByTheme } from './componentMap';

export type ComponentProps = PageContentsItem & {
	// any common props for all components
	display?: TDisplayScreen;
	variant?: string;
};
interface Props {
	componentProps: ComponentProps;
	typename: string;
	tags?: Array<string>;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const logger = getLogger('design-system');

export const ComponentResolver = ({ typename, componentProps, tags }: Props) => {
	const { variant } = componentProps;
	const { config } = useAppContext();
	const { themeId } = config;
	const componentsMap = getComponentMapByTheme(themeId, variant || '');
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
	const shouldDisplayContent = canDisplayContentOnScreen(isSmallScreen, componentProps?.display);

	if (!shouldDisplayContent) {
		logger.info(`Not displaying ${typename} for current screen size`);
		return null;
	}

	// @ts-ignore
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const Component = componentsMap[typename];

	if (!Component) {
		logger.info(`No Template Component for ${typename}`);
		return null;
	}

	logger.info(`Created ${typename} ${componentProps?.sys.id}`);

	return <Component {...componentProps} tags={tags} variant={variant} />;
};
